query GetProductsSidebarCounts {
    productsSidebarCounts {
        numProducts
        numUncategorizedProducts
        numDeletedProducts
    }
}
